module.exports = __webpack_public_path__ + "img/train-9.b5ea8eef.jpg";